"use client";

import { useEffect, useState } from "react";
import { lockScroll } from "../../../utils/lock-scroll";
import { createPortal } from "react-dom";
import { AnimatePresence, motion } from "framer-motion";
import styles from "./ModalRoot.module.scss";
import CloseIcon from "../../../../public/gallery/close_extra_large-24.svg";

const backdrop = {
  visible: { opacity: 0.3 },
  hidden: { opacity: 0 },
};

const content = {
  hidden: {
    scale: 0.8,
    opacity: 0,
    transition: {
      duration: 0.2,
    },
  },
  visible: {
    scale: 1,
    opacity: 1,
    transition: {
      duration: 0.2,
    },
  },
};

const ModalRoot = ({ showModal, children, setShowModal }) => {
  const [modalRoot, setModalRoot] = useState();

  useEffect(() => {
    const root = document?.getElementById("modal-root");
    setModalRoot(root);
    if (showModal) {
      lockScroll(true);
    }

    return () => {
      lockScroll(false);
    };
  }, [showModal]);

  if (modalRoot) {
    return createPortal(
      <AnimatePresence exitBeforeEnter>
        {showModal && (
          <>
            <motion.div
              className={styles.modal}
              variants={backdrop}
              animate="visible"
              initial="hidden"
              exit="hidden"
              onClick={() => setShowModal(false)}
            />

            <motion.div
              className={styles.content}
              variants={content}
              animate="visible"
              initial="hidden"
              exit="hidden"
            >
              <CloseIcon
                className={styles.icon}
                onClick={() => setShowModal(false)}
              />
              {children}
            </motion.div>
          </>
        )}
      </AnimatePresence>,
      modalRoot
    );
  }

  return null;
};

export default ModalRoot;
